import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL } from 'src/environments/environment';
import { Audits } from '../interfaces/audits';
import { Pagination } from '../interfaces/pagination';
import { PaginatorService } from '../services/paginator.service';
@Injectable({
  providedIn: 'root'
})
export class AuditsService {
  private readonly http = inject(HttpClient);
  private readonly paginatorService = inject(PaginatorService);

  listAudits(filters: Params, paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<Audits>> {
    let params = new HttpParams();
    if (filters.sort !== null) {
      filters.sort = 'auditEventDate:desc';
    }
    if (filters.applicationId) {
      params = params.set('applicationId', filters.applicationId);
    }

    return this.http
      .get<PaginatedResponse<Audits>>(`${URL.url}audits/${this.paginatorService.getQueryParams(paginatorFilters)}`, { params })
      .pipe(map((response: Pagination<Audits>) => this.getPaginatedResponse(response)));
  }

  /**
   * Get paginated response
   *
   * @param pagination the pagination
   */
  getPaginatedResponse(pagination: Pagination<Audits>): PaginatedResponse<Audits> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }
}
